import { VehicleModelType } from '@orcar/common';

// 노출 순서: 경형 / 준중형 / 중형 / SUV / 승합 / 전기 / 고급 / 수입 / 슈퍼
// ("펫과 함께"는 차종이 아닌 isWithPet 토글로 별도 노출)
export const CAR_TYPE = [
  {
    id: VehicleModelType.URBAN,
    label: '경형',
  },
  {
    id: VehicleModelType.COMPACT,
    label: '준중형',
  },
  {
    id: VehicleModelType.MIDSIZE,
    label: '중형',
  },
  {
    id: VehicleModelType.SUV,
    label: 'SUV',
  },
  {
    id: VehicleModelType.RV,
    label: '승합',
  },
  {
    id: VehicleModelType.EV,
    label: '전기차',
  },
  {
    id: VehicleModelType.LUXURY,
    label: '고급',
  },
  {
    id: VehicleModelType.IMPORTED,
    label: '수입',
  },
  {
    id: VehicleModelType.SUPERCAR,
    label: '슈퍼카',
  },
];
